/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BrandCancellationInput } from '../models/BrandCancellationInput';
import type { BrandCancellationPreview } from '../models/BrandCancellationPreview';
import type { BrandRefundDecision } from '../models/BrandRefundDecision';
import type { BrandRefundManagement } from '../models/BrandRefundManagement';
import type { BrandRefundVersion } from '../models/BrandRefundVersion';
import type { BrandRefundView } from '../models/BrandRefundView';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class BrandRefundsService {
    /**
     * @param brandId
     * @param orderId
     * @returns BrandCancellationPreview OK
     * @throws ApiError
     */
    public static getApiBrandRefundsOrdersPreview(
        brandId: number,
        orderId: string,
    ): CancelablePromise<BrandCancellationPreview> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/brand-refunds/{brandId}/orders/{orderId}/preview',
            path: {
                'brandId': brandId,
                'orderId': orderId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param brandId
     * @param orderId
     * @param requestBody
     * @returns BrandRefundView OK
     * @throws ApiError
     */
    public static postApiBrandRefundsOrdersCancellations(
        brandId: number,
        orderId: string,
        requestBody?: BrandCancellationInput,
    ): CancelablePromise<BrandRefundView> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/brand-refunds/{brandId}/orders/{orderId}/cancellations',
            path: {
                'brandId': brandId,
                'orderId': orderId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns BrandRefundManagement OK
     * @throws ApiError
     */
    public static getApiBrandRefunds(): CancelablePromise<Array<BrandRefundManagement>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/brand-refunds',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param orderId
     * @param requestBody
     * @returns BrandRefundView OK
     * @throws ApiError
     */
    public static postApiBrandRefundsOrdersCancellations1(
        orderId: string,
        requestBody?: BrandCancellationInput,
    ): CancelablePromise<BrandRefundView> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/brand-refunds/orders/{orderId}/cancellations',
            path: {
                'orderId': orderId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns BrandRefundView OK
     * @throws ApiError
     */
    public static postApiBrandRefundsDecision(
        id: string,
        requestBody?: BrandRefundDecision,
    ): CancelablePromise<BrandRefundView> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/brand-refunds/{id}/decision',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns BrandRefundView OK
     * @throws ApiError
     */
    public static postApiBrandRefundsRetry(
        id: string,
        requestBody?: BrandRefundVersion,
    ): CancelablePromise<BrandRefundView> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/brand-refunds/{id}/retry',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param id
     * @returns BrandRefundView OK
     * @throws ApiError
     */
    public static postApiBrandRefundsReconcile(
        id: string,
    ): CancelablePromise<BrandRefundView> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/brand-refunds/{id}/reconcile',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param id
     * @returns any OK
     * @throws ApiError
     */
    public static postApiBrandRefundsNotificationsRetry(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/brand-refunds/{id}/notifications/retry',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
